import "./polyfills.js";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";
import "./styles/global.css";
import App from "./App.jsx";
import CookieConsentRoot from "./CookieConsentRoot.jsx";

ReactDOM.hydrateRoot(
  document.getElementById("root"),
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// TEMP-DISABLED-FOR-DEBUG
// ReactDOM.createRoot(document.getElementById("cookie-consent-root")).render(
//   <React.StrictMode>
//     <CookieConsentRoot />
//   </React.StrictMode>
// );
